import { EMetroTravelType } from '../../../packages/api-models/common/json_query';

export function getDefaultTravelTimeForType(type: EMetroTravelType | null): number {
  switch (type) {
    case EMetroTravelType.AgentTransport:
    case EMetroTravelType.MapTransport:
      return 30;

    case EMetroTravelType.Any:
    case EMetroTravelType.AgentFoot:
    case EMetroTravelType.MapFoot:
      return 45;
  }

  return 45;
}
